import { render, staticRenderFns } from "./Stallion.vue?vue&type=template&id=41d71cd0&"
import script from "./Stallion.vue?vue&type=script&lang=js&"
export * from "./Stallion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports